import { Modal, message } from "antd";
import React from "react";

const ActionsModal = ({
  isModalOpen,
  setIsModalOpen,
  onSubmit,
  form,
  button,
  context,
  children,
}) => {
  return (
    <>
      {button}
      <Modal
        title={context}
        open={isModalOpen}
        onCancel={() => {
          form.resetFields();
          setIsModalOpen(false);
        }}
        width={"40vw"}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              onSubmit(values);
            })
            .catch((e) =>
              message.error("Preencha todos os campos corretamente!"),
            );
        }}
        okText={"Confirmar"}
        cancelText={"Cancelar"}
        centered
      >
        {children}
      </Modal>
    </>
  );
};

export default ActionsModal;
